import React from 'react';
import { useHistory } from 'react-router-dom';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import log from 'loglevel';

import { Box } from 'Components/Base';
import { useSearchMyCourseProvider } from 'Context/SearchMyCourseProvider';
import { withConfig } from 'Context/ConfigContext';
import { withOffset } from 'Context/LayoutContext';
import { myProfile } from 'Redux/user-profile/selectors';
import { withCapacitor } from 'Util/Capacitors';
import { navigateToTungKai } from 'Util/navigateToTungKai';
import { COURSE_MODE } from 'Util/constants';
import { canRedirectToTungKai } from 'Routes/MyCourses/Components/utils.js';

import CourseBanner from '../Components/CourseBanner';
import CourseContainer from '../Components/CourseContainer';
import { CourseList } from '../Components/CourseList';
import BackgroundImage from '../Components/BackgroundImage';

const FullScreenMyCourses = ({ appConfig, user, capacitorContext, props }) => {
  const history = useHistory();
  const { debouncedSearchTerm } = useSearchMyCourseProvider();
  const { myCourses, tungKai: tungKaiConfig } = appConfig;
  const { openInApp } = capacitorContext;
  const userId = user.id;

  const bannerUrl = myCourses?.bannerUrl;
  const hasSearchMyCourse = debouncedSearchTerm !== '';

  const onCourseCardClick = async (courseId, mode) => {
    const { enable, enableWhiteList, whitelist, courseCardRedirectPath } = tungKaiConfig || {};

    const canGoToTungKai = canRedirectToTungKai({
      enable,
      enableWhiteList,
      whitelist,
      userId,
    });

    if (mode === COURSE_MODE.TUNGKAI && canGoToTungKai) {
      const redirectPath =
        (courseCardRedirectPath || '/').replace('{courseId}', courseId) + `?scrollToTop=true`;

      return navigateToTungKai({
        redirectPath,
        config: appConfig,
        openInApp,
      });
    }

    if (history) {
      history.push(`/classroom/${courseId}`);
    } else {
      log.error('History object is missing!');
    }
  };

  return (
    <Box {...props}>
      {hasSearchMyCourse ? (
        <BackgroundImage px={0} pb={5} $backgroundImage={bannerUrl} />
      ) : (
        <CourseBanner user={user} onCourseCardClick={onCourseCardClick} />
      )}
      <CourseContainer px={0}>
        <CourseList onCourseCardClick={onCourseCardClick} />
      </CourseContainer>
    </Box>
  );
};

export default compose(
  withConfig,
  connect((state) => ({
    user: myProfile(state) ?? {},
  })),
  withOffset,
  withCapacitor
)(FullScreenMyCourses);
